import { environment } from 'src/environments/environment';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from "@angular/platform-browser";
import { MatIconRegistry } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AutorizationService } from 'src/app/api/autorization.service';

@Component({
  selector: 'app-refresh-token',
  templateUrl: './refresh-token.component.html',
  styleUrls: ['./refresh-token.component.scss']
})
export class RefreshTokenComponent implements OnInit {

   constructor(public router: Router, private ActivatedRoute: ActivatedRoute, public snackBar: MatSnackBar, private authService: AutorizationService, private formBuilder: FormBuilder, private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {}



  refresh_token
  loading = false


  todayCode: string = ''; // Stocke la date du jour (ddMMyyyy)
  userCode: string = ''; // Stocke le code saisi par l'utilisateur
  isCodeValid: boolean = false; // Contrôle l'affichage du div

  ngOnInit(): void {
    this.setTodayCode();
  }

  setTodayCode(): void {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois commence à 0
    const year = today.getFullYear();

    this.todayCode = `${day}${month}${year}`; // Format ddMMyyyy
  }

  checkCode(): void {
    this.isCodeValid = this.userCode === this.todayCode; // Vérifie si le code est correct
  }


  getUserWithRefreshToken() {

    if (!this.refresh_token) {
      this.openSnackBarError("Refresh token introuvable")
      return;
    }
    this.loading = true;
    this.authService.refreshTokenOauth2(this.refresh_token).subscribe(
      data => {

    

                            this.loading = false;
                            this.router.navigate(['/']);
                   

        
      },
      erro => {
        this.loading = false;
        console.log(erro)
        this.openSnackBarError(erro.message)
       

      });

  }

  openSnackBarError(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['error-snackbar'],
      duration: 20000,
    });
  }
  

}
